import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgMenuLeftIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="menu_left_svg__nc-icon-wrapper">
      <path data-color="color-2" d="M30 17H2a1 1 0 1 1 0-2h28a1 1 0 1 1 0 2z" />
      <path d="M30 8H2a1 1 0 1 1 0-2h28a1 1 0 1 1 0 2zM16 26H2a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgMenuLeftStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgMenuLeftIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const MenuLeftIcon: any = SvgMenuLeftStyle;
export default MenuLeftIcon;
